/**
 * @generated SignedSource<<ca6f782cb23d795179f966ce85459a1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithLinks_shoppingWith$data = {
  readonly links: {
    readonly links: ReadonlyArray<{
      readonly label: string | null;
      readonly url: string | null;
    } | null> | null;
    readonly title: string | null;
  } | null;
  readonly " $fragmentType": "ShoppingWithLinks_shoppingWith";
};
export type ShoppingWithLinks_shoppingWith$key = {
  readonly " $data"?: ShoppingWithLinks_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithLinks_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithLinks_shoppingWith",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShoppingWithLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShoppingWithLink",
          "kind": "LinkedField",
          "name": "links",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "e776fb080bd7a52e41ac72b94930c6f9";

export default node;
